import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import DSTextBox from '@elliemae/ds-basic/form/TextBox';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextBox = /*#__PURE__*/function (_Component) {
  _inherits(TextBox, _Component);

  var _super = _createSuper(TextBox);

  function TextBox(props) {
    var _this;

    _classCallCheck(this, TextBox);

    _this = _super.call(this, props);
    _this.inputRef = /*#__PURE__*/React.createRef();
    _this.state = {
      value: props.value
    };
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TextBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.inputRef && _this2.inputRef.current) {
          _this2.inputRef.current.focus();
        }
      }, 50);
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(_ref) {
      var key = _ref.key,
          value = _ref.target.value;
      var onValue = this.props.onValue;

      if (key === 'Enter') {
        onValue(value);
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      // PUI-2553 prevent form submit on `Enter` keypress
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var onValue = this.props.onValue;
      var value = e.target.value;
      onValue(value);
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref2) {
      var value = _ref2.target.value;
      this.setState({
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      return /*#__PURE__*/React.createElement(DSTextBox, _extends({
        "data-testid": "ds-datagrids-editable-text-box"
      }, this.props, {
        innerRef: this.inputRef,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        value: value
      }));
    }
  }]);

  return TextBox;
}(Component);

_defineProperty(TextBox, "defaultProps", {
  onValue: function onValue() {
    return null;
  }
});

export default TextBox;
//# sourceMappingURL=TextBox.js.map
